import { render, staticRenderFns } from "./DeviceAdminSUP.vue?vue&type=template&id=5c164a3a&"
import script from "./DeviceAdminSUP.vue?vue&type=script&lang=js&"
export * from "./DeviceAdminSUP.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAdminSUP.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports